// Fixed invoice payment information; preserve the supplied QR payload verbatim.
export const MT_INVOICE_PAYMENT_PAYLOAD = 'SPC 0200 1 CH303000522617678601E S MYL AG Spichermatt 17 6370 Stans CH EUR QRR 000000000000000000000000011 EPD'
